<template>
  <b-modal :id="`delete-vehicle-modal-${id}`" title="BootstrapVue">
    <div class="delete-vehicle-modal">
      <b-alert :show="error && error.length ? true : false" variant="danger">
        <div v-if="Array.isArray(error)">
          <div class="d-flex flex-column my-1" v-for="(error_text, index) in error" :key="index">
            {{ error_text }}
          </div>
        </div>
        <div v-else>
          <div v-html="error || '&nbsp;'"></div>
        </div>
      </b-alert>
      <div class="text-center">
        <img src="@/assets/images/driver-popup-vehicle.svg" alt="popup vehicle" />
        <h3>{{ $t('delete-vehicle') }}</h3>
        <h4>{{ $t('delete-vehicle-confirmation') }}</h4>
      </div>
      <div class="d-flex justify-content-center align-items-center">
        <base-button class="primary" :cus_style="deleteBtnStyle" @click="submit" :loading="loading">
          {{ $t('delete') }}
        </base-button>
        <base-button
          class="secondary mx-2"
          :cus_style="cancelBtnStyle"
          @click="$bvModal.hide(`delete-vehicle-modal-${id}`)"
          :loading="loading"
        >
          {{ $t('cancel') }}
        </base-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import VehicleService from '@/services/vehicle.service'

export default {
  name: 'DeleteModal',
  emits: ['refreshData'],
  props: ['id'],
  data() {
    return {
      loading: false,
      error: null,
      cancelBtnStyle: 'display:inline-block;width:92px;',
      deleteBtnStyle: 'display:inline;width:92px;',
    }
  },
  methods: {
    submit() {
      // delete api call

      this.loading = true
      this.error = null

      VehicleService.delete(this.id)
        .then((res) => {
          this.$emit('refreshData')
          this.$bvModal.hide(`delete-vehicle-modal-${this.id}`)
        })
        .catch(({ message }) => {
          this.error = message
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
  i18n: {
    messages: {
      en: require('@/services/i18n/locales/en/vehicles.json'),
      ar: require('@/services/i18n/locales/ar/vehicles.json'),
    },
  },
}
</script>

<style lang="scss" scoped>
.delete-vehicle-modal {
  padding-block: 30px;
}
h3 {
  color: var(--color-17);
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 32px;
}
h4 {
  color: var(--color-17);
  font-size: 1.125rem;
  line-height: 36px;
}
</style>
